
const state = {
    skills: [],
};

const mutations = {
    setSkills(state, value) {
        state.skills = value;
    },
};

const actions = {};

const getters = {
    skills: (state) => state.skills,
};

export default {
    namespaced: true,
    state,
    mutations,
    actions,
    getters,
};
